module.exports = __webpack_public_path__ + "img/پاکت-کارتی.14bae38c.png";